var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 0H27C18.729 0 12 6.729 12 15V57C12 65.271 18.729 72 27 72H45C53.271 72 60 65.271 60 57V15C60 6.729 53.271 0 45 0ZM39 63H33C31.344 63 30 61.656 30 60C30 58.344 31.344 57 33 57H39C40.656 57 42 58.344 42 60C42 61.656 40.656 63 39 63Z",
    fill: "#001E3A"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_60_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 25C33.0836 25.0032 30.2875 26.1631 28.2253 28.2253C26.1631 30.2875 25.0032 33.0836 25 36C25.55 50.575 46.45 50.5686 47 36C46.9968 33.0836 45.8369 30.2875 43.7747 28.2253C41.7125 26.1631 38.9164 25.0032 36 25ZM39.2083 31.4167C41.0087 31.4414 41.0087 35.9752 39.2083 36C37.408 35.9752 37.408 31.4414 39.2083 31.4167ZM32.7917 31.4167C34.592 31.4414 34.592 35.9752 32.7917 36C30.9913 35.9752 30.9913 31.4414 32.7917 31.4167ZM36.0064 42.4167C32.9484 42.4167 31.0638 39.9233 30.5 37.8333C32.2816 38.3939 34.1329 38.7025 36 38.75C37.8692 38.7021 39.7225 38.3936 41.5064 37.8333C40.9427 39.9233 39.0644 42.4167 36.0064 42.4167Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_60_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile1);
export default __webpack_public_path__ + "static/media/mobile1.edf9037e5653b73223e7b103c72f257c.svg";
export { ForwardRef as ReactComponent };